<template>
    <v-dialog v-model="dialog" max-width="360" persistent>
      <v-card :class="typeClass" class="pa-6 text-center rounded-xl elevation-10">
        <v-card-actions>
          <v-spacer/> <v-icon size="48" :color="iconColor" class="mb-4">{{ icon }}</v-icon><v-spacer/></v-card-actions>
       
        <v-card-title class="text-h5 font-weight-bold mb-2">
          {{ title }}
        </v-card-title>
        <v-card-text class="text-button mb-4">
          {{ message }}
        </v-card-text>
        <v-btn :color="btnColor" variant="flat" class="px-6" @click="handleClose">
          OK
        </v-btn>
      </v-card>
    </v-dialog>
  </template>
  
  <script setup>
  import { ref, computed } from 'vue';
  import { useRouter } from 'vue-router';
  import eventBus from '@/utils/eventBus';
  
  const dialog = ref(false);
  const message = ref('');
  const type = ref('success');
  
  const router = useRouter();
  
  eventBus.on('showDialog', ({ type: t, message: msg }) => {
    type.value = t;
    message.value = msg;
    dialog.value = true;
  });
  
  const title = computed(() => (type.value === 'error' ? 'Oops...' : 'Success!'));
  const icon = computed(() => (type.value === 'error' ? 'mdi-alert-circle-outline' : 'mdi-check-circle-outline'));
  const iconColor = computed(() => (type.value === 'error' ? 'red' : 'green'));
  const btnColor = computed(() => (type.value === 'error' ? 'red-darken-1' : 'green-darken-1'));
  const typeClass = computed(() => (type.value === 'error' ? 'error-dialog' : 'success-dialog'));
  
  const handleClose = () => {
    dialog.value = false;
    if (type.value === 'success') {
      router.push({ name: 'signIn' });
    }
  };
  </script>
  
  <style scoped>
  .success-dialog {
    background-color: #f0fdf4;
    border: 1px solid #c8e6c9;
  }
  
  .error-dialog {
    background-color: #fff1f0;
    border: 1px solid #ffcdd2;
  }
  
  .v-card-title {
    font-weight: 700;
  }
  
  .v-btn {
    text-transform: none;
  }
  </style>
  